import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/outline"
import React, { useEffect, useState } from "react"
import { Link, useParams } from "react-router-dom"
import axiosInstance from "../../../../services/Interceptor"
import OrderTimeline from "./OrderTimeline"
import "./MyOrder.css"

export default function CancelledOrderDetails() {
	let {id} = useParams()
	const [orderDetails, setOrderDetails] = useState([])
	const [subtotal, setSubtotal] = useState()

	/* order details */
	useEffect(() => {
		axiosInstance
			.get(`orders/api/v1/orders/customer/${id}/`)
			.then((res) => {
				// console.log(res.data);
				setOrderDetails(res.data)
			})
			.catch((err) => {
				console.log(err)
			})
	}, [])

	/* subtotal */
	useEffect(() => {
		if (orderDetails) {
			const Total = orderDetails.order_items?.reduce((prev, current) => (prev = prev + current.total_price), 0)
			setSubtotal(Total)
		}
	}, [orderDetails])

	/* total order fee */
	const total = subtotal + parseInt(orderDetails.shipping_cost) - orderDetails.discount



	const [open, setOpen] = useState(false)




	return (
		<>
			<section className='container mx-auto px-3 sm:px-0'>
				<div className=' h-full w-full'>
					<div className='container mx-auto space-y-4'>
						<div className=' sm:flex flex-col sm:flex-row justify-between sm:items-center  space-y-2 mx-2 '>
							<h2 className='text-[#282828] text-xs sm:text-sm font-semibold flex justify-start sm:items-center gap-x-1 sm:gap-x-2 whitespace-nowrap'>
								Canclled Orders <ArrowRightIcon className='h-4 w-4 object-contain' /> Order <span className='text-[#3076CE]'>#{orderDetails && orderDetails.order_id}</span>
							</h2>

							<h2 className='text-[#3076CE] text-sm font-semibold  underline underline-offset-1'>
								{" "}
								<Link to='/my-account' className='flex items-center text-[#3076CE] text-xs sm:text-sm font-semibold '>
									<ArrowLeftIcon className='h-4 w-4 mx-1 object-contain' /> Back
								</Link>
							</h2>
						</div>

						{/* summary */}

						<div className='grid grid-cols-1 sm:grid-cols-12 space-y-4 sm:space-y-0 gap-x-4 text-sm'>
							<div className='sm:col-span-10 border border-gray-200 bg-white  rounded-lg shadow p-4 flex flex-col justify-between'>
								<div className=' grid grid-cols-8 items-start space-x-3'>
									<div className='col-span-6'>
										<span className='text-gray-700 font-semibold'>Shipping Address: </span>
										<span className='text-gray-500'>{orderDetails && `${orderDetails.shipping_address?.address}, ${orderDetails.shipping_address?.street}, ${orderDetails.shipping_address?.state}, ${orderDetails.shipping_address?.city} `}</span>
									</div>
									<div className=' col-span-2 space-y-1'>
										<div className='flex justify-end items-center gap-x-2'>
											<p className='text-gray-700 font-light'>Payment Status :</p>
											<div className='flex items-center text-sm font-bold text-[#22DA9B] '>
												{orderDetails.payment_method == "cash" ? (
													"Cash"
												) : (
													<>
														<svg width='18' height='15' viewBox='0 0 12 11' fill='none' xmlns='http://www.w3.org/2000/svg'>
															<path
																fillRule='evenodd'
																clipRule='evenodd'
																d='M5.60245 0.0831466C5.6575 0.0516977 5.71981 0.0351563 5.78322 0.0351562C5.84662 0.0351562 5.90893 0.0516977 5.96398 0.0831466L11.0663 2.99878C11.1221 3.03064 11.1685 3.07668 11.2007 3.13224C11.233 3.18779 11.25 3.25088 11.25 3.31512V3.83994C11.25 5.44789 10.7262 7.01208 9.75783 8.29572C8.78944 9.57936 7.42922 10.5126 5.88308 10.9541C5.8178 10.9727 5.74863 10.9727 5.68335 10.9541C4.13733 10.5124 2.77725 9.57909 1.8089 8.2955C0.840547 7.0119 0.316625 5.44783 0.316406 3.83994L0.316406 3.31512C0.316427 3.25088 0.333427 3.18779 0.365684 3.13224C0.397942 3.07668 0.44431 3.03064 0.500091 2.99878L5.60245 0.0831466ZM5.47124 7.84237L8.61867 3.907L8.05012 3.45216L5.36628 6.80586L3.46529 5.22195L2.99879 5.78175L5.47124 7.84237Z'
																fill='url(#paint0_linear_2567_6147)'
															/>
															<defs>
																<linearGradient id='paint0_linear_2567_6147' x1='11.25' y1='5.50159' x2='-19.7191' y2='16.3969' gradientUnits='userSpaceOnUse'>
																	<stop stopColor='#22DA9B' />
																	<stop offset='1' stopColor='#2995FC' />
																</linearGradient>
															</defs>
														</svg>
														Paid
													</>
												)}
											</div>
										</div>
										<div className='flex justify-end items-center gap-x-2 whitespace-nowrap'>
											<span className='text-gray-700 font-light'>Paid By </span>
											<span className='text-gray-500'>payment_method</span>
										</div>
									</div>
								</div>
								<div className=' sm:grid grid-cols-8 items-start space-x-3'>
									<div className='col-span-6 flex justify-start items-center gap-x-2'>
										<figure>
											<img className='h-6 w-6 object-contain mx-auto' src='/images/bangladesh.png' alt='flag' />
										</figure>
										<span className='text-gray-500'>(+880) 1755-2121283</span>
									</div>
									<div className='col-span-2 '>
										<div className='flex justify-end items-center gap-x-2'>
											<span className='text-gray-700 font-light'>Order Status: </span>
											<span className='text-red-500 font-medium'>Order Cancelled</span>
										</div>
									</div>
								</div>
							</div>
							<div className=' sm:col-span-2 border border-gray-200 bg-white  rounded-lg shadow p-4 space-y-3'>
								<p className='text-gray-700 text-center font-medium'>Express Delivery</p>
								<div className='space-y-2'>
									<div className='flex justify-between items-center text-gray-500'>
										<p>Subtotal</p>
										<p>{`৳ ${subtotal}`}</p>
									</div>
									<div className='flex justify-between items-center text-gray-500'>
										<p>Shipping Fee</p>
										<p> {`৳ ${orderDetails.shipping_cost}`}</p>
									</div>
									<div className='flex justify-between items-center text-gray-500'>
										<p>Discount</p>
										<p>{` -৳ ${orderDetails.discount}`}</p>
									</div>
								</div>
								<div className='flex justify-between items-center text-gray-500 border-t border-gray-300 pt-3'>
									<p>Total</p>
									<p>
										{" "}
										৳ <span className='text-[#3076CE]  font-semibold'>{total}</span>
									</p>
								</div>
							</div>
						</div>

						{/* track delivery */}

						<div className='space-y-3 border-t border-gray-300 pt-4 '>
							<div className=' border border-gray-200 bg-white  rounded-md shadow p-3 sm:p-8 flex flex-col justify-between'>
								<OrderTimeline order={orderDetails} />
							</div>
						</div>

						<div className='space-y-2 py-4'>
							<p className='text-gray-500'>
								Reason: <span className='font-bold text-gray-700'> Found Somewhere In Cheaper Rate</span>
							</p>

							<p className='font-medium text-gray-700'>Message From The Customer</p>
							<article className="text-gray-500">Dhaka, Bangladesh, flat no 50 houser 3 road 5 Quae tibi placent quicunq prosunt aut diligebat multum, quod Quae tibi Shipping Address: Dhaka, Bangladesh, flat no 50 houser 3 road 5 Quae tibi placent quicunq prosunt aut diligebat multum, quod Quae tibi Shipping Address: Dhaka, Bangladesh, flat no 50 houser 3 road 5 Quae tibi placent quicunq prosunt aut diligebat multum, quod Quae tibi </article>
						</div>

						{/* products */}
						<div className='space-y-3'>
							<div className='flex justify-between items-center  space-y-2 mx-2 border-t border-gray-300 pt-4'>
								<h2 className='text-[#282828] text-sm font-semibold flex justify-start items-center gap-x-2'>
									Package By
									<span className='text-[#3076CE]'>#Aungur Store</span>
								</h2>
							</div>
							{/* dummy products */}
							{orderDetails &&
								orderDetails.order_items?.map((item, index) => (
									<div key={index} className=' border border-gray-200 bg-white  rounded-md shadow px-4 py-2 flex flex-col justify-between'>
										<div className='h-auto w-full flex items-center justify-between gap-x-3 '>
											<div className='flex items-center justify-start gap-x-3'>
												<figure>
													<img className='h-14 w-14 object-contain rounded-lg' src={item.product_image_url} alt='search product' />
												</figure>

												<div className='flex flex-col justify-between '>
													<p className='text-gray-600 font-medium text-sm sm:text-base'>{item.product_title}</p>
													<p className='text-xs'>Qty: {item.quantity}</p>
												</div>
											</div>
											<div>
												<p className='text-sm sm:text-base flex justify-start items-end gap-x-1'>
													৳ <span className='text-[#3076CE]   font-semibold'>{item.total_price}</span>
												</p>
											</div>
										</div>
									</div>
								))}
						</div>
					</div>
				</div>
			</section>
		</>
	)
}
